/* ===============================================================
   SOEGEORD-SYNONYMER  (15-10, Claude)
   ---------------------------------------------------------------
   Shopify har nedlagt synonymerne i Search & Discovery-appen
   (sep. 2026). I stedet oversaettes korte soegeord her, foer
   soegningen sendes, saa man faar praecis samme resultater:

     eco  ->  organic          (.com - paa .dk er det øko -> økologisk)

   Virker i soegefeltet i headeren (baade forslag mens man skriver
   og Enter), paa soegesiden og ved direkte links til /search?q=eco.
   Kun hele ord rammes - fx «eco-friendly» er uroert.

   Flere ord: tilfoej dem i SEARCH_SYNONYMS (smaa bogstaver).
   Ligger oeverst i filen, saa fejl laengere nede ikke stopper den.
   =============================================================== */
(function () {
  var SEARCH_SYNONYMS = { 'eco': 'organic' };

  function rewrite(q) {
    if (!q) return q;
    return q.split(/(\s+)/).map(function (w) {
      var star = w.slice(-1) === '*' ? '*' : '';
      var base = (star ? w.slice(0, -1) : w).toLowerCase();
      return Object.prototype.hasOwnProperty.call(SEARCH_SYNONYMS, base) ? SEARCH_SYNONYMS[base] + star : w;
    }).join('');
  }

  function isSearchPath(path) {
    return /\/search\/?$/.test(path || '');
  }

  // 1) Direkte link til soegesiden
  try {
    if (isSearchPath(window.location.pathname)) {
      var params = new URLSearchParams(window.location.search);
      var q0 = params.get('q');
      var q1 = rewrite(q0);
      if (q0 && q1 !== q0) {
        params.set('q', q1);
        window.location.replace(window.location.pathname + '?' + params.toString());
      }
    }
  } catch (e) {}

  // 2) Formularer der sender til /search (header, soegeside)
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !isSearchPath((form.getAttribute('action') || '').split('?')[0])) return;
    var input = form.querySelector('input[name="q"]');
    if (input) {
      var nq = rewrite(input.value);
      if (nq !== input.value) input.value = nq;
    }
  }, true);

  // 3) Forslag mens man skriver (temaet henter dem med fetch)
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (resource, init) {
      try {
        if (typeof resource === 'string' && resource.indexOf('q=') !== -1) {
          var url = new URL(resource, window.location.origin);
          if (isSearchPath(url.pathname)) {
            var q = url.searchParams.get('q');
            var nq = rewrite(q);
            if (q && nq !== q) {
              url.searchParams.set('q', nq);
              resource = url.pathname + url.search;
            }
          }
        }
      } catch (e) {}
      return nativeFetch.call(window, resource, init);
    };
  }
})();

// -------------------

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* CLEAR CART DRAWER  */
const clearBtn = document.querySelector('[data-clear-cart]');

function clearCart() {
    fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({}),
    })
        .then((res) => { console.log(res), res.json() })
        .then(() => document.documentElement.dispatchEvent(new CustomEvent("cart:refresh")));
}


clearBtn.addEventListener('click', (event) => {
    event.preventDefault();
    clearCart()
});

// -------------------

/* CART TERMS AND CONDITIONS */
const termsOverlay = document.querySelector('.terms-overlay');
const termsContent = document.querySelector('.terms-content-wrapper');
const termsDeny = document.querySelector('.terms-deny');
const termsAccept = document.querySelector('.terms-accept');

function showTerms() {
    termsOverlay.classList.add('terms-overlay--active');
    termsContent.classList.add('terms-content-wrapper--active');
}

function hideTerms() {
    termsOverlay.classList.remove('terms-overlay--active');
    termsContent.classList.remove('terms-content-wrapper--active');
}
function validateTerms(e) {
    e.preventDefault();
    const cartTerms = document.querySelector('input[name=checkbox]');

    if (cartTerms.checked) {
        window.location = '/checkout';
    } else {
        showTerms();
    }
}

termsOverlay?.addEventListener('click', () => {
    hideTerms();
});

termsAccept?.addEventListener('click', () => {
    window.location = '/checkout';
});

termsDeny?.addEventListener('click', () => {
    hideTerms();
});

// -------------------

// GEO JS fjernet 09-2026 - erstattet af sprogvaelgeren i headeren (snippets/locale-switcher.liquid)

//   const productItemImage = document.querySelectorAll(".ProductItem__Image");
//   const productItem = document.querySelectorAll(".ProductItem");

//   productItem?.forEach((item)=>{
//       if(item.outerText.includes("DISORDER")){
//         item.parentElement.classList.add("hide");
//         item.classList.add("hide");
//       }
//   })

